import EpdServiceClient from "../../api/EpdServiceClient";

export async function getFile(id: string) {
  const response = await EpdServiceClient.get(`api/file/${id}`, {
    responseType: "blob",
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
